export const UPDATE_CURRENT_NEWS_SORT_ID = 'UPDATE_CURRENT_NEWS_SORT_ID'

export const UPDATE_CURRENT_NEWS_SORT_NAME = 'UPDATE_CURRENT_NEWS_SORT_NAME'

export const UPDATE_CURRENT_ROUTER_NAME = 'UPDATE_CURRENT_ROUTER_NAME'

export const UPDATE_NEWS_SORTS = 'UPDATE_NEWS_SORTS'

export const UPDATE_VENUE_PAGE_TYPE = 'UPDATE_VENUE_PAGE_TYPE'



// WEBPACK FOOTER //
// ./src/store/mutations-types.js